module.exports = __webpack_public_path__ + "on_ramp_right.svg?b37738446542bc9900b82ddfd35d438b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/on_ramp_right.svg
// module id = 201
// module chunks = 0